import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { InfoModal } from '~/components/InfoModal'
import { SectionTitle } from '~/components/layout/Sections'
import { Body } from '~/components/typography/Content'

export function WhatIsAikoaModal() {
  const { t } = useTranslations('feedback')

  return (
    <InfoModal triggerLabel={t(($) => $.flow.whatIsAikoa)}>
      <View className="gap-5">
        <SectionTitle className="text-center">{t(($) => $.flow.whatIsAikoa)}</SectionTitle>
        <Body className="text-pretty text-center text-base/relaxed">
          {t(($) => $.flow.whatIsAikoaIntro)}
        </Body>
        <Body className="text-pretty text-center text-base/relaxed">
          {t(($) => $.flow.whatIsAikoaDescription)}
        </Body>
      </View>
    </InfoModal>
  )
}
